import type { SVGProps } from 'react';
const DawnFlagPH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-PH_svg__a)">
      <path fill="#DD1C34" d="M0 16h22V7.467H9.778l.698.533z" />
      <path fill="#0D4BC3" d="M22 7.467H9.778L0 0h22z" />
      <path
        fill="#FDD64D"
        d="M1.572 3.2c.289 0 .523-.239.523-.533a.53.53 0 0 0-.523-.534.53.53 0 0 0-.524.534c0 .294.234.533.524.533m6.285 5.333c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .295.234.533.523.533m-5.762 4.8a.53.53 0 0 1-.523.534.53.53 0 0 1-.524-.534c0-.294.234-.533.524-.533.289 0 .523.239.523.533m1.466-4.272-.896 1.403.34-1.638a1 1 0 0 1-.15-.152l-1.608.346 1.378-.912a1 1 0 0 1 0-.216L1.247 6.98l1.608.347q.068-.084.15-.153l-.34-1.637.896 1.403a1 1 0 0 1 .212 0l.896-1.403-.34 1.637q.082.069.15.153l1.608-.347-1.378.913a1 1 0 0 1 0 .216l1.378.912-1.608-.346a1 1 0 0 1-.15.152l.34 1.638-.896-1.403a1 1 0 0 1-.212 0"
      />
    </g>
  </svg>
);
export default DawnFlagPH;
